"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.envFrom = exports.oxygenIdFrom = exports.oxygenTokenFrom = exports.productVersionFrom = exports.productLineCodeFrom = void 0;
function productLineCodeFrom(analytics) {
    return analytics.contextService.context.facets.product.line_name;
}
exports.productLineCodeFrom = productLineCodeFrom;
function productVersionFrom(analytics) {
    return analytics.contextService.context.facets.product.build_id;
}
exports.productVersionFrom = productVersionFrom;
function oxygenTokenFrom(analytics) {
    var _a;
    return (_a = analytics.contextService.context.tokenInfo) === null || _a === void 0 ? void 0 : _a.userToken;
}
exports.oxygenTokenFrom = oxygenTokenFrom;
function oxygenIdFrom(analytics) {
    var _a;
    return (_a = analytics.contextService.context.tokenInfo) === null || _a === void 0 ? void 0 : _a.userId;
}
exports.oxygenIdFrom = oxygenIdFrom;
function envFrom(analytics) {
    return analytics.contextService.context.config.env;
}
exports.envFrom = envFrom;
